import { LocalityModel } from '@/types/LocalityModel'
import { replaceTags } from './replace-tag-service'
import { ContentBlock, Page } from '@/payload-types'

type ItemFromBreadCrums = NonNullable<Page['breadcrumbs']>[number]

/**
 * Client-safe : ce module ne doit plus jamais importer les jeux de donnees de
 * localites. La resolution slug -> `LocalityModel` se fait cote serveur via
 * `locality-lookup.server.ts`, et le modele resolu est injecte ici — soit par
 * `createLocalityService` (serveur), soit par le `LocalityProvider` (client).
 */
export class LocalityService {
  private readonly _localite: LocalityModel | undefined
  private readonly _localiteSlug: string | undefined

  constructor(
    localiteSlug: string | undefined,
    localite?: LocalityModel | undefined,
  ) {
    this._localiteSlug = localiteSlug
    this._localite = localite
  }

  addLocaliteToUrl(resultItem: string) {
    if (this._localiteSlug) {
      const splitPathname = this._localiteSlug.split('/')
      const splitSlug = splitPathname[splitPathname.length - 1]
      return resultItem + '/localites/' + splitSlug!
    }
  }

  /**
   * Remplace la ville en fin de chemin courant par une autre, en gardant le
   * même préfixe (page pays ou service) — utilisé pour lier vers les
   * localités voisines sans reconstruire ce préfixe depuis chaque appelant.
   */
  changeLocaliteInUrl(newVilleSlug: string) {
    if (!this._localiteSlug) return undefined

    const segments = this._localiteSlug.split('/')
    segments[segments.length - 1] = newVilleSlug

    return segments.join('/')
  }

  addBreadcrumbLocaliteToUrl(resultItem: ItemFromBreadCrums[]) {
    const splitPathname = this._localiteSlug!.split('/')
    const splitSlug = splitPathname[splitPathname.length - 1]
    const lastCrumb = resultItem[resultItem.length - 1]?.url

    return lastCrumb + '/localites/' + splitSlug
  }

  getLocaliteName() {
    return this._localite?.name
  }

  replaceTagsInContent(data: ContentBlock) {
    if (this._localite)
      return data.columns?.map((data) => {
        if (data.link) {
          data.link.label = replaceTags(data.link?.label, this._localite!)
        }
      })
  }

  replaceTags(data: string) {
    return replaceTags(data, this._localite!)
  }
}
